import React from "react";
import { Provider } from "react-redux";
import { theme } from "./theme/theme";
import { ThemeProvider } from "styled-components";
import MainRoutes from "./routes";
import store from "./redux/store";
// eslint-disable-next-line
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import PropTypes from "prop-types";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastProvider } from "./context/ToastContext";
import { msalConfig } from '../src/auth/authConfig';
import { FeatureFlagProvider } from "./context/FeatureFlagContext";

/**
 * This component is the entry point for APP.
 * It includes all providers and routes configured.
 * @returns {ReactNode} returns JSX element with all providers and routes.
 */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
      cacheTime: 1000 * 60 * 10, // Cache remains active for 10 minutes
      retry: 2, // Retry failed queries 2 times
      refetchOnWindowFocus: false, // Disable refetching on window focus
    },
    mutations: {
      retry: 1, // Retry failed mutations once
    },
  },
});
function App({ msalInstance }) {
  return (
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <ToastProvider>
              <FeatureFlagProvider>
                <MainRoutes />
              </FeatureFlagProvider>
            </ToastProvider>
          </Provider>
        </ThemeProvider>
      </QueryClientProvider>
    </MsalProvider>
  );
}

App.propTypes = {
  msalInstance: PropTypes.object.isRequired, // This line can be removed as msalInstance is initialized inside the component now
};

export default App;
